<head>
  <title>No Encontrado</title>
  <link rel="icon" href="" type="image/x-icon">
  <link rel="icon" href="data:,">
</head>
<body>
    <div class="container">
      <div class="content">
        <h1>404</h1>
        <h2>Pagina No Encontrada</h2>
        <p>La página solicitada no pudo ser encontrada.</p>
      </div>
    </div>
</body>